import React, { useEffect, useState } from "react";
import ActivationRow from "./ActivationRow";
import { useDispatch, useSelector } from "react-redux";
import {
  kit,
  successMessage,
  fileSuccessMessage,
  totalPages,
  totalRecords,
} from "redux-store/kit/kit.selector";
import { getKits, messageClean } from "redux-store/kit/kit.slice";
import { AppDispatch } from "redux-store/store";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";

const SecondSection = () => {
  const [isMobile, setIsMobile] = useState<any>(window.innerWidth <= 1020);
  const kits = useSelector(kit);
  const successmessage = useSelector(successMessage);
  const fileMessage = useSelector(fileSuccessMessage);
  const pages = useSelector(totalPages);
  const records = useSelector(totalRecords);
  // let activePage = 2;
  const [activePage, setActivePage] = useState(1);
  const [pageValue, setPageValue] = useState({
    start: 1,
    second: 2,
    end: 3,
  });
  const incrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start + 1,
      second: pageValue.second + 1,
      end: pageValue.end + 1,
    });
  };
  const decrementPageHandler = () => {
    setPageValue({
      ...pageValue,
      start: pageValue.start - 1,
      second: pageValue.second - 1,
      end: pageValue.end - 1,
    });
  };

  const onPageClickHandler = (pageNumber: any) => {
    setActivePage(pageNumber);
    dispatch(getKits(pageNumber));
  };

  const dispatch = useDispatch<AppDispatch>();
  useEffect(() => {
    dispatch(messageClean());
    dispatch(getKits(1));
  }, []);

  useEffect(() => {
    if (successmessage === "Kit created successfully") {
      dispatch(getKits(activePage));
    }
  }, [successmessage]);

  useEffect(() => {
    // dispatch(messageClean());
    if (fileMessage === "Kit created successfully") {
      dispatch(getKits(1));
    }
  }, [fileMessage]);

  const [maxIndexToShow, setMaxIndexToShow] = useState<any>((isMobile: any) => {
    if (isMobile) {
      return 3;
    } else {
      return kits && kits.length > 0 ? kits.length - 1 : 0;
    }
  });

  const [showViewBtn, setShowViewBtn] = useState(true);
  const handleViewMoreClick = () => {
    if (kits && maxIndexToShow >= kits.length - 1) {
      setShowViewBtn(false);
    } else {
      setShowViewBtn(true);
      setMaxIndexToShow((prevMaxIndex: any) => prevMaxIndex + 2);
    }
  };

  const displayData = () => {
    if (isMobile) {
      setMaxIndexToShow(3);
    } else {
      setMaxIndexToShow((prevMaxIndex: any) => {
        if (kits && kits?.length > 0) {
          return kits?.length - 1;
        } else {
          return prevMaxIndex;
        }
      });
    }
  };
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 1020);
    displayData();
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    displayData();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isMobile]);
  useEffect(() => {
    setMaxIndexToShow(kits && kits.length > 0 ? kits.length - 1 : 0);
  }, [kits]);
  return (
    <>
      <div className=" tw-w-[80%] lg:tw-w-[90%] tw-flex tw-justify-between tw-mx-auto tw-rounded-xl tw-py-6 lg:tw-py-12 lg:tw-px-10 tw-bg-[#FFFFFF]">
        {/* main content */}
        <div className="tw-w-[80%] lg:tw-w-[90%] tw-mx-auto tw-flex tw-justify-between">
          {/* 1st row */}
          <div className="tw-w-full tw-flex tw-flex-col tw-gap-6">
            <div className="tw-flex tw-justify-between tw-flex-wrap tw-gap-6 tw-items-center tw-flex-col lg:tw-flex-row">
              {kits && kits.length !== 0 ? (
                <>
                  {kits.map((actCode, index) => {
                    if (index <= maxIndexToShow) {
                      return (
                        <ActivationRow
                          code={actCode.code}
                          status={actCode.status}
                        />
                      );
                    }
                  })}

                  <div className="tw-w-full md:tw-w-full tw-m-auto tw-flex tw-flex-col md:tw-flex-row tw-gap-[1rem] tw-items-center md:tw-justify-between sm:tw-justify-center tw-px-[3%] tw-mt-[2rem]">
                    <div className="">
                      <p className="tw-text-base tw-text-tabelHeadingColor tw-font-fontPara tw-font-medium">
                        Showing{" "}
                        {kits && kits.length > 0
                          ? Math.min(records, 20 * activePage)
                          : ""}{" "}
                        of {records}
                      </p>
                    </div>
                    <div className="flex flex-row gap-[0.5rem] tw-items-center">
                      <button
                        onClick={decrementPageHandler}
                        disabled={pageValue.start <= 1 ? true : false}
                        className={
                          pageValue.start <= 1
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowLeftIcon />
                      </button>
                      <button
                        disabled={pageValue.start > pages ? true : false}
                        className={
                          pageValue.start === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.start > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.start)}
                      >
                        {pageValue.start}
                      </button>
                      <button
                        disabled={pageValue.second > pages ? true : false}
                        className={
                          pageValue.second === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-2"
                            : pageValue.second > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-2"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md tw-mr-2 hover:tw-bg-reddishOrange hover:tw-text-white"
                        }
                        onClick={() => onPageClickHandler(pageValue.second)}
                      >
                        {pageValue.second}
                      </button>
                      <button
                        disabled={pageValue.end > pages ? true : false}
                        className={
                          pageValue.end === activePage
                            ? "tw-bg-reddishOrange tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-white tw-border-[1px] tw-rounded-md tw-mr-1"
                            : pageValue.end > pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-bg-white tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem]  md:tw-py-[0.5rem] tw-text-black tw-border-[1px] tw-rounded-md hover:tw-bg-reddishOrange hover:tw-text-white tw-mr-1"
                        }
                        onClick={() => onPageClickHandler(pageValue.end)}
                      >
                        {pageValue.end}
                      </button>
                      <button
                        onClick={incrementPageHandler}
                        disabled={pageValue.end >= pages ? true : false}
                        className={
                          pageValue.end >= pages
                            ? "tw-bg-[#CCCCCC] tw-px-[0.5rem] md:tw-px-[1.25rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-[#666666] tw-border-[1px] tw-rounded-md tw-mr-1"
                            : "tw-px-[0.5rem] md:tw-px-[1.05rem] tw-py-[0.25rem] md:tw-py-[0.5rem] tw-text-sm md:tw-text-md tw-rounded-md tw-text-white tw-font-fontHeading tw-font-bold tw-bg-reddishOrange tw-mr-1"
                        }
                      >
                        <KeyboardDoubleArrowRightIcon />
                      </button>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <span className="tw-text-sm tw-text-gray-600 tw-text-center">
                    No Kits Created
                  </span>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SecondSection;
